module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/leads/css/settings.component.css
// module id = ./src/app/modules/leads/css/settings.component.css
// module chunks = main